import { WellStratumFieldsEdit } from '../../../../types/form-types'
import FractionCardEdit from './fraction-card-edit'
import { fractionTypes } from './lithology-types'
import { SetValue, ValidationErrors } from '../../../hooks/use-edit-form'
import { Heading } from '@msaf/core-react'

interface FractionCardEditWrapperProps {
  isLoading: boolean
  stratum: Partial<WellStratumFieldsEdit>
  setValue: SetValue<WellStratumFieldsEdit>
  validationErrors: ValidationErrors
  isNewRecord?: boolean
  isExistingOrDecommissioned?: boolean
}
export default function FractionCardEditWrapper({
  isLoading,
  stratum,
  setValue,
  validationErrors,
  isNewRecord,
  isExistingOrDecommissioned,
}: FractionCardEditWrapperProps) {
  return (
    <>
      <Heading isSkeleton={isLoading} level={3}>
        Fractions
      </Heading>
      {fractionTypes.map((fractionType) => {
        return (
          <FractionCardEdit
            isLoading={isLoading}
            stratum={stratum}
            fractionType={fractionType}
            setValue={setValue}
            key={fractionType}
            validationErrors={validationErrors}
            isNewRecord={isNewRecord}
            isExistingOrDecommissioned={isExistingOrDecommissioned}
          />
        )
      })}
    </>
  )
}
